module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-group pagination",
    attrs: {
      "role": "group",
      "aria-label": "Pagination"
    }
  }, [_c('button', {
    class: ['btn', 'btn-' + _vm.secondaryVariant, _vm.btnSize],
    attrs: {
      "type": "button",
      "disabled": _vm.currentPage == 1
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        (_vm.currentPage == 1) ? _vm._return: _vm.currentPage--
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("«")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPrev),
      expression: "showPrev"
    }],
    class: ['btn', 'btn-' + _vm.secondaryVariant, _vm.btnSize, _vm.currentPage === 1 ? 'active' : ''],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.currentPage = 1
      }
    }
  }, [_vm._v("1\n    ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPrev),
      expression: "showPrev"
    }],
    class: ['btn', 'btn-' + _vm.secondaryVariant, _vm.btnSize]
  }, [_vm._v("...")]), _vm._v(" "), _vm._l((_vm.pageLinks), function(_, index) {
    return _c('button', {
      class: ['btn',
        _vm.btnSize,
        _vm.btnVariant(index),
        index + _vm.diff === _vm.currentPage ? 'active' : '',
        index + _vm.diff !== _vm.currentPage ? 'hidden-xs-down' : ''
      ],
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.currentPage = index + _vm.diff
        }
      }
    }, [_vm._v(_vm._s(index + _vm.diff) + "\n    ")])
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNext),
      expression: "showNext"
    }],
    class: ['btn', 'btn-' + _vm.secondaryVariant, _vm.btnSize]
  }, [_vm._v("...")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNext),
      expression: "showNext"
    }],
    class: ['btn', 'btn-' + _vm.secondaryVariant, _vm.btnSize, _vm.numberOfPages === _vm.currentPage ? 'active' : ''],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.currentPage = _vm.numberOfPages
      }
    }
  }, [_vm._v(_vm._s(_vm.numberOfPages) + "\n    ")]), _vm._v(" "), _c('button', {
    class: ['btn', 'btn-' + _vm.secondaryVariant, _vm.btnSize],
    attrs: {
      "type": "button",
      "disabled": _vm.currentPage == _vm.numberOfPages
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        (_vm.currentPage == _vm.numberOfPages) ? _vm._return: _vm.currentPage++
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("»")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c06e358e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/pagination.vue
// module id = 259
// module chunks = 0